<template>
    <div class="p-0">
        <history-tabs @change-tab="activateTab">
            <template v-slot:content>
                <empty-state
                    v-if="! isLoadData && (ordersList && ordersList.length < 1)"
                    @filter-status-wrap="filterStatusWrap"
                ></empty-state>
                <div class="container-wrapp" v-else-if="! isMobile">
                  <div v-if="showActsColumnStatus" class="acts-actions">
                    <div v-if="showActsColumnStatus" class="acts-item select-all-acts" data-toggle="tooltip" data-html="true" data-id="details-discount-tooltip" :title="showPriceDetails" v-loading="loadAllData || loadingParent">
                      <input v-model="showActsColumn" type="checkbox" name="select_all_akts" id="select_all_acts"  @change="selectAllAktsToggle($event)">
                      <span>Додати усі продукти в акт</span>
                    </div>
                    <div v-if="shouldShowActButton(1) && showActsColumnStatus && Object.keys(margeActsList).length > 0" class="acts-item send-acts">
                      <a type="button" class="btn btn-orange filter-button" @click="generatePdfPreview" v-loading="loadAllData || loadingParent">
                        Подати акт на виплату КВ
                      </a>
                    </div>
                  </div>
                  <div class="header-block">
                        <ul class="columns-block">
                            <li class="column">Тип статусу</li>
                            <li class="column">Номер поліса</li>
                            <li class="column">Дата</li>
                            <li class="column">Страхувальник</li>
                            <li class="column">Страховий платіж, грн</li><!-- Вартість, грн -->
                            <li v-if="$store.getters.USER.organizationId && $store.getters.USER.organizationType !== 'head'" class="column"></li>
                            <li v-else class="column">Комісійна винагорода, грн</li><!-- Заробіток, грн -->
                        </ul>
                        <div v-if="!isMobile" class="history-view-mode">
                          <el-button v-if="ordersViewMode === 'compact'" class="history-view-btn" size="mini" @click="changeOrdersView">
                            <svg width="32" height="32" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13 3H8C7.44772 3 7 3.44772 7 4V9C7 9.55228 7.44772 10 8 10H13C13.5523 10 14 9.55228 14 9V4C14 3.44772 13.5523 3 13 3Z" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M13 14H8C7.44772 14 7 14.4477 7 15V20C7 20.5523 7.44772 21 8 21H13C13.5523 21 14 20.5523 14 20V15C14 14.4477 13.5523 14 13 14Z" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18 4H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18 9H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18 15H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M18 20H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </el-button>
                          <el-button v-if="ordersViewMode === 'full'" class="history-view-btn" size="mini"  @click="changeOrdersView">
                            <svg width="32" height="32" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 12H7.01" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M7 18H7.01" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M7 6H7.01" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12 12H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12 18H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12 6H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </el-button>
                        </div>
                    </div>
                    <div v-if="isLoadData && ordersViewMode === 'compact'">
                        <row-block-compact-skeleton v-for="index in 4" :key="index"></row-block-compact-skeleton>
                    </div>
                    <div v-else-if="isLoadData">
                      <row-block-skeleton v-for="index in 4" :key="index"></row-block-skeleton>
                    </div>
                    <div v-else v-for="(order, index) in computedOrdersList" class="order-list-item">
                         <!-- compact card -->
                        <order-card-compact
                          v-if="ordersViewMode === 'compact'"
                          :order="order"
                          :list-query="listQuery"
                          :marge-acts-list="margeActsList"
                          :show-acts-column-status="showActsColumnStatus"
                          :load-more-options="loadMoreOptions"
                          @acts-toggle="aktsToggle"
                          @take-contract="takeContract"
                        />
                        <!-- full card -->
                        <div v-else class="row-block">
                            <ul class="columns-block">
                                <li class="column">
                                    <div class="column-block">
                                        <div class="d-flex align-center">
                                              <span v-if="showActsColumnStatus && order.showCheckbox" class="acts-checkbox">
                                                     <input
                                                       v-if="order.showCheckbox"
                                                       :disabled="[6].includes(order.statusId)"
                                                       :readonly="[6].includes(order.statusId)"
                                                       type="checkbox" name="akt" :id="'act-'+order.id"
                                                       @change="aktsToggle(order,$event)"
                                                       :checked="margeActsList.hasOwnProperty(order.id)"
                                                     >
                                              </span>
                                          <span class="order-type" style="display: flex; align-items: center">
                                                  <span>{{ showTypeInsurance(order) }}</span>
                                              </span>
                                        </div>
                                        <span v-if="isProlongationOrder(order)" style="margin-top: 10px">
                                              <svg style="margin-top: -7px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <line x1="10" y1="4" x2="10" y2="12" stroke="#EF4E4E" stroke-width="2"/>
                                                <line x1="10" y1="13.5" x2="10" y2="16" stroke="#EF4E4E" stroke-width="2"/>
                                                <circle cx="10" cy="10" r="9" stroke="#EF4E4E" stroke-width="2"/>
                                              </svg>
                                              <span>
                                                Cкоро закінчується
                                              </span>
                                            </span>
                                        <div class="bottom-block" v-if="order.act.length > 0 && !getParentId()">
                                          <span class="dark-link" style="text-decoration: underline;" v-html="showActName(order)"></span>
                                        </div>
                                        <div class="bottom-part order-status">
                                          <div class="bottom-block"><!-- right-border -->
                                            <span>Статус:</span>
                                            <div>
                                              <div :class="['status', getStatusClass(order)]">
                                                <span>{{ showStatusName(order) }}</span>
                                              </div>
                                              <div v-if="!$store.getters.USER.organizationId" class="status-badges-column">
                                                <div v-if="checkOrderPaid(order) && (showStatusId(order) === 5 || order.typeId === 5)" class="payment-status status paid mt-1"><span>Сплачено</span></div>
                                                <div v-if="checkOrderPaid(order) && getOrderPaymentSystemTitle(order)" class="payment-system-badge mt-1">
                                                  <PaymentSystemIcon class="payment-system-badge__icon" />
                                                  <span>{{ getOrderPaymentSystemTitle(order) }}</span>
                                                </div>
                                                <div v-if="isCancellation(order)" class="cancellation-status status mt-1"><span>На ануляції</span></div>
                                                <div v-if="!checkOrderPaid(order) && (showStatusId(order) === 5 || showStatusId(order) === 10)" class="payment-status status mt-1"><span>Не сплачено</span></div>
                                                <file-input v-if="order.manualTypeId && !checkOrderPaid(order) && (order.payments.length === 0 || order.payments.some(item => item.invoice.receipt === null))" :http-request="(options) => uploadReceipt(options, order)" @remove-file="receiptLoaded = false" @upload-success="$emit('init-orders-list');">
                                                  <template #button>
                                                    <div class="payment-status mt-1 h-auto d-inline-block p-1" style="line-height: 1">
                                                      <span style="line-height: 1">Завантажити квитанцію</span>
                                                    </div>
                                                  </template>
                                                </file-input>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </li>
                                <li class="column">
                                  <div class="column-block">
                                    <a  class="order-number" target="_blank"  :href="showMtsbuLink(order)" v-if="showMtsbuLink(order)">
                                      {{ showMtsbuCode(order) }}<br />{{ showMtsbuCodeAdditionalInfoAlt(order) }}
                                    </a>
                                    <span v-else-if="showMtsbuCode(order)" class="order-number">
                                                {{ showMtsbuCode(order) }}
                                            </span>
                                    <span class="order-number" v-else>&mdash;</span>
                                    <div class="bottom-part order-user">
                                      <div class="bottom-block"><!-- right-border -->
                                        <div class="option-block">
                                          <div class="option">Точка продажу:</div>
                                          <div class="user-name"
                                               data-toggle="tooltip" data-placement="bottom"
                                               :title="showNameInsured(order)">
                                            {{ showNameInsured(order) }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li class="column">
                                  <div class="column-block">
                                    <div>
                                      <div class="date-block">
                                        <div class="text">Створений:</div>
                                        <span v-if="order.createdAt" class="date">{{ order.createdAt }}</span>
                                        <span v-else class="date">&mdash;</span>
                                      </div>
                                      <div class="date-block">
                                        <div class="text">Початок:</div>
                                        <span v-if="showStartedAtContract(order)"
                                              class="date">{{ showStartedAtContract(order) }}</span>
                                        <span v-else class="date">&mdash;</span>
                                      </div>
                                      <div class="date-block">
                                        <div class="text">Закінчення:</div>
                                        <span v-if="showFinishedAtContract(order)"
                                              class="date">{{ showFinishedAtContract(order) }}</span>
                                        <span v-else class="date">&mdash;</span>
                                      </div>
                                      <div v-if="showTerminated(order)" class="date-block">
                                        <div class="text">Дата ДР:</div>
                                        <span
                                          class="date">{{ showTerminated(order) }}</span>
                                      </div>
                                    </div>
                                    <div class="bottom-part order-company">
                                      <div class="bottom-block"><!-- right-border -->
                                        <div class="option-block">
                                          <div class="option">СК:</div>
                                          <div class="result"
                                               data-toggle="tooltip" data-placement="bottom"
                                               :title="order.companyInfo.publicName + ` ` + (order.offer.programmName ? order.offer.programmName : '')">
                                            <ellipsis
                                              :data="order.companyInfo.publicName +` `+ (order.offer.programmName ? order.offer.programmName : '')">
                                            </ellipsis>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li class="column">
                                  <div class="column-block">
                                    <div class="order-insured">
                                      <a class="result dark-link" v-if="order.client_id" :href="'/clients/'+order.client_id">
                                        <div v-if="showNameInsurantSurname(order)">
                                          <span>{{ showNameInsurantSurname(order) }}</span>
                                          <span> {{ showNameInsurantName(order) }}</span>
                                          <span> {{ showNameInsurantPatronymic(order) }}</span>
                                        </div>
                                        <div v-else>
                                          <span> {{ showNameInsurantName(order) }}</span>
                                        </div>
                                      </a>
                                      <div v-else>
                                        <div v-if="showNameInsurantSurname(order)">
                                          <span>{{ showNameInsurantSurname(order) }}</span>
                                          <span> {{ showNameInsurantName(order) }}</span>
                                          <span> {{ showNameInsurantPatronymic(order) }}</span>
                                        </div>
                                        <div v-else>
                                          <span> {{ showNameInsurantName(order) }}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="bottom-part order-company">
                                      <div class="bottom-block"><!-- right-border -->
                                        <span class="result">{{ order.insuranceObject.number }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li class="column">
                                  <div class="column-block">
                                    <div>
                                      <div class="price-block">
                                        <div class="text">Первісна:</div>
                                        <span class="date">{{ showPrice(order) }}</span>
                                      </div>
                                      <div v-if="showDiscount(order) && order.discountPrice != order.price"  class="price-block">
                                        <div class="text">Зі знижкою:</div>
                                        <span class="date">{{ showAllPrice(order) }}
<!--                                          <i class="icon question" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Первісна вартість може бути знижена за рахунок знижки посередника та за рахунок виключення місяців, з періоду дії полісу."></i>-->
                                        </span>
                                      </div>
                                      <div v-if="order.landingPromoCode" class="price-block">
                                        <div class="text">Промокод «{{ order.landingPromoCode }}»:</div>
                                        <span class="date">&minus;{{ order.landingPromoAmount }} грн ({{ order.landingPromoPercent }}%)</span>
                                      </div>
                                    </div>
                                    <div class="bottom-part">
                                      <div class="bottom-part">
                                        <div v-if="isProlongation(order) && !isFisReferal()">
                                          <svg style="margin-bottom: 4px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6 3.2002H4.4C3.07452 3.2002 2 4.27471 2 5.6002V11.6002C2 12.9257 3.07452 14.0002 4.4 14.0002H11.6C12.9255 14.0002 14 12.9257 14 11.6002V5.6002C14 4.27471 12.9255 3.2002 11.6 3.2002Z" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5.59961 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10.4004 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M2 6.80029H14" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                          </svg>

                                          <a @click="prolong(order)" href="javascript:void(0);">
                                            <span  style="margin-left: 1px;" class="option">Продовжити</span>
                                          </a>
                                          <div class="d-inline-flex">
                                            <client-info :client="order.insurant"  ref="clientInfo"></client-info>
                                          </div>
                                        </div>
                                        <div v-else-if="isDraft(order) && !isFisReferal()">
                                          <svg style="margin-bottom: 4px" width="16" height="16" viewBox="0 0 16 16"
                                               fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                              d="M12.0415 7.74999C12.0398 8.88764 11.5871 9.9782 10.7827 10.7826C9.97822 11.5871 8.88766 12.0398 7.75001 12.0415C6.61223 12.0399 5.52149 11.5873 4.71686 10.7828C3.91223 9.97841 3.45936 8.88777 3.45751 7.74999C3.45896 6.61199 3.91167 5.52103 4.71636 4.71634C5.52104 3.91166 6.61201 3.45894 7.75001 3.45749C8.70651 3.45749 9.58251 3.77249 10.295 4.30049L9.40401 5.19249L13.619 6.32049L12.489 2.10699L11.544 3.05199C10.4712 2.18163 9.13151 1.70689 7.75001 1.70749C4.41301 1.70899 1.70901 4.41249 1.70801 7.74999C1.70901 11.0875 4.41301 13.7915 7.75001 13.7915C11.087 13.7915 13.7915 11.0875 13.7915 7.74999H12.0415Z"
                                              fill="#999DA6"/>
                                          </svg>
                                          <span
                                            v-if="order.typeId === orderTypes['miniKasko']"
                                            @click="$router.push({name:'miniKaskoOrder', params: {orderId: order.id}})"
                                            class="option"
                                          >Продовжити</span>
                                          <a v-else @click="declare(order,false,false,1)" href="javascript:void(0);">
                                                    <span class="option">
                                                    Продовжити
                                                </span>
                                          </a>
                                        </div>
                                        <div v-else-if="isDeclared(order) && !isFisReferal()">
                                          <svg style="margin-bottom: 5px" width="16" height="16"
                                               viewBox="0 0 16 16" fill="none"
                                               xmlns="http://www.w3.org/2000/svg">
                                            <mask id="path-1-inside-1" fill="white">
                                              <rect x="1" y="5" width="14" height="10" rx="1"/>
                                            </mask>
                                            <rect x="1" y="5" width="14" height="10" rx="1"
                                                  stroke="#24282C" stroke-width="4"
                                                  mask="url(#path-1-inside-1)"/>
                                            <mask id="path-2-inside-2" fill="white">
                                              <rect x="4" y="1" width="8" height="6" rx="1"/>
                                            </mask>
                                            <rect x="4" y="1" width="8" height="6" rx="1"
                                                  stroke="#24282C" stroke-width="4"
                                                  mask="url(#path-2-inside-2)"/>
                                          </svg>
                                          <span
                                            v-if="order.typeId === orderTypes['miniKasko']"
                                            @click="$router.push({name:'miniKaskoOrder', params: {orderId: order.id}})"
                                            class="option"
                                          >Продовжити</span>
                                          <a v-else @click="declare(order,false,false,2)" href="javascript:void(0);">
                                                    <span class="option">
                                                    Продовжити
                                                </span>
                                          </a>
                                        </div>
                                        <div v-else-if="isConcluded(order) && order.typeId !== 2" class="show-btn">
                                            <span class="option image">
                                                  <svg style="margin-bottom: 5px" width="16" height="16"
                                                       viewBox="0 0 16 16" fill="none"
                                                       xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0)">
                                                    <path
                                                      d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z"
                                                      stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                      stroke-linejoin="round"/>
                                                    <path
                                                      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                                      stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                      stroke-linejoin="round"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0">
                                                        <rect width="16" height="16" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                </span>

                                          <span
                                            v-if="order.typeId === orderTypes['miniKasko']"
                                            @click="$router.push({name:'miniKaskoOrder', params: {orderId: order.id}})"
                                            class="option"
                                          >Переглянути</span>
                                            <a v-else @click="goToOrderInfo(order)" href="javascript:void(0);">
                                                <span class="option">
                                                  Переглянути
                                                </span>
                                            </a>
                                        </div>
                                        <div v-else-if="isOverdue(order) && !isFisReferal()">
                                                <span class="option image">
                                                     <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                                          class="option-loader spinner-border"
                                                          style="height: 14px; width: 14px; margin-bottom: 7px; margin-right: 2px"
                                                          role="status">
                                                    </div>
                                                     <svg v-else style="margin-bottom: 5px;" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                          xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                          d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                                                          stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                          stroke-linejoin="round"/>
                                                        <path
                                                          d="M3.3335 10H2.66683C2.31321 10 1.97407 9.85952 1.72402 9.60947C1.47397 9.35942 1.3335 9.02028 1.3335 8.66666V2.66666C1.3335 2.31304 1.47397 1.9739 1.72402 1.72385C1.97407 1.4738 2.31321 1.33333 2.66683 1.33333H8.66683C9.02045 1.33333 9.35959 1.4738 9.60964 1.72385C9.85969 1.9739 10.0002 2.31304 10.0002 2.66666V3.33333"
                                                          stroke="#24282C" stroke-width="2" stroke-linecap="round"
                                                          stroke-linejoin="round"/>
                                                    </svg>
                                                </span>
                                          <a @click="copy(order)" href="javascript:void(0);">
                                                    <span class="option">
                                                        Копіювати
                                                    </span>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li class="column">
                                  <div class="column-block">
                                    <div v-if="!$store.getters.USER.organizationId || $store.getters.USER.organizationType === 'head'">
                                      <div class="price-block" v-if="order.allEarnings">
                                        <div :class="['text', {'long' : showTerminated(order)}]">Загальний:</div>
                                        <span class="price">{{ order.allEarnings }}</span>
                                      </div>
                                      <div class="price-block">
                                        <div :class="['text', {'long' : showTerminated(order)}]">Ваш:</div>
                                        <span v-if="order.myEarnings" class="price">{{ order.myEarnings }}</span>
                                        <span v-else class="price">&mdash;</span>
                                      </div>
                                      <div class="price-block" v-if="order.isPartnerOrder">
                                        <div :class="['text', {'long' : showTerminated(order)}]">Агента:</div>
                                        <span v-if="order.partnerEarnings" class="price">{{
                                            order.partnerEarnings
                                          }}</span>
                                        <span v-else class="date">&mdash;</span>
                                      </div>
                                      <div class="price-block" v-if="showTerminated(order)">
                                        <div :class="['text', {'long' : showTerminated(order)}]">Утримано за ДР:</div>
                                        <span class="price">{{ showTerminatedSum(order) }}</span>
                                      </div>
                                    </div>
                                    <div class="bottom-part">
                                      <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                           class="option-loader spinner-border"
                                           style="height: 14px; width: 14px; margin-bottom: 4px;"
                                           role="status">
                                      </div>
                                      <more-options v-else :status-order="showStatusId(order)"
                                                    :order="order"
                                                    :order-type="order.typeId"
                                                    :data-contract-extra-files="order.contract.extraFiles"
                                                    @download-draft="showDraft(order)"
                                                    @download-contract="takeContract(order, 1)"
                                                    @download-acts-completed-work="showActsOfCompletedWork(order)"
                                                    @show-order="goToOrderInfo(order)"
                                                    @proceed-order="declare(order,false,false,1)"
                                                    @confirm-order="declare(order,false,false,2)"
                                                    @open-mtsbu-link="openMtsbuLink(order)"
                                                    @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                                    @get-payment-invoice="getPaymentInvoice(order)"
                                                    @get-instant-loan="getInstantLoan(order)"
                                                    :is-exist-mtsbu-link="showMtsbuLink(order)"
                                                    @copy-order="copy(order)">
                                      </more-options>
                                    </div>
                                  </div>
                                </li>
                            </ul>

                            <!-- dgo additional sub-card -->
                            <cross-product-card
                              v-if="order.typeId == 1 && showDgoPrice(order)"
                              :order="order"
                              :product-type="4"
                              :list-query="listQuery"
                              :marge-acts-list="margeActsList"
                              :show-acts-column-status="showActsColumnStatus"
                              :load-more-options="loadMoreOptions"
                              @acts-toggle="aktsToggle"
                            />
                            <!-- autolawyer additional sub-card -->
                            <cross-product-card
                              v-if="order.typeId == 1 && showAutolawyerPrice(order)"
                              :order="order"
                              :product-type="6"
                              :list-query="listQuery"
                              :marge-acts-list="margeActsList"
                              :show-acts-column-status="showActsColumnStatus"
                              :load-more-options="loadMoreOptions"
                              @acts-toggle="aktsToggle"
                            />

                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="mobile-orders-columns-block">
                        <div v-if="isLoadData">
                            <row-mobile-block-skeleton v-for="index in 4" :key="index"></row-mobile-block-skeleton>
                        </div>
                        <div v-else>
                            <div v-if="showActsColumnStatus" class="acts-actions">
                                <div v-if="showActsColumnStatus" class="acts-item select-all-acts" data-toggle="tooltip" data-html="true" data-id="details-discount-tooltip" :title="showPriceDetails" v-loading="loadAllData || loadingParent">
                                    <input v-model="showActsColumn" type="checkbox" name="select_all_akts" id="select_all_acts"  @change="selectAllAktsToggle($event)">
                                    <span>Додати усі продукти в акт</span>
                                </div>
                                <div v-if="shouldShowActButton(1) && showActsColumnStatus && Object.keys(margeActsList).length > 0" class="acts-item send-acts">
                                    <a type="button" class="btn btn-orange filter-button" @click="generatePdfPreview" v-loading="loadAllData || loadingParent">
                                      Подати акт на виплату КВ
                                    </a>
                                </div>
                            </div>
                            <div v-for="order in computedOrdersList" class="order-list-item-mobile">
                                <!-- compact card -->
                                <order-card-compact
                                  v-if="ordersViewMode === 'compact'"
                                  :order="order"
                                  :key="order.id"
                                  :list-query="listQuery"
                                  :marge-acts-list="margeActsList"
                                  :show-acts-column-status="showActsColumnStatus"
                                  :load-more-options="loadMoreOptions"
                                  @acts-toggle="aktsToggle"
                                  @take-contract="takeContract"
                                />
                                <!-- old mobile card -->
                                <div v-else class="row order-data">
                                    <div class="col-6">
                                      <div v-if="showActsColumnStatus && order.showCheckbox" class="acts-checkbox">
                                        <input
                                          v-if="order.showCheckbox"
                                          :disabled="[6].includes(order.statusId)"
                                          :readonly="[6].includes(order.statusId)"
                                          type="checkbox" name="akt" :id="'act-'+order.id"
                                          @change="aktsToggle(order,$event)"
                                          :checked="margeActsList.hasOwnProperty(order.id)"
                                        >
                                      </div>
                                    </div>
                                    <div class="row-mobile first-row">
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Тип поліса</div>
                                          <div class="option-value">{{ showTypeInsurance(order) }}</div>
                                          <div class="bottom-block" v-if="order.act">
                                            <span style="text-decoration: underline;font-weight: 700;font-size: 12px;color: black;" v-html="showActName(order)"></span>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Номер поліса</div>
                                          <div class="option-value mtsbu-value">
                                            <a :href="showMtsbuLink(order)" v-if="showMtsbuLink(order)">
                                              {{ showMtsbuCode(order) }}
                                            </a>
                                            <span v-else-if="showMtsbuCode(order)" class="order-number">
                                                        {{ showMtsbuCode(order) }}
                                                    </span>
                                            <span class="order-number" v-else>&mdash;</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row-mobile">
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Страхувальник</div>
                                          <a class="dark-link" :href="'/clients/'+order.client_id">
                                            <div class="option-value">
                                              {{ showNameInsurantSurname(order) }}
                                            </div>
                                            <div class="option-value">
                                              {{ showNameInsurantName(order) }}
                                            </div>
                                            <div v-if="showNameInsurantPatronymic(order)" class="option-value">
                                              {{ showNameInsurantPatronymic(order) }}
                                            </div>
                                          </a>
                                          <div class="option-value">
                                            <div class="mb-2">{{ order.insuranceObject.number }}</div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">СК:</div>
                                          <div class="option-value word-wrap">
                                            <span>{{ order.companyInfo.publicName }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row-mobile">
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Вартість, грн</div>
                                          <div class="sub-options">
                                            <div>
                                              <span class="sub-option-title">Первісна:</span>
                                              <span class="option-value">{{ showPrice(order) }}</span>
                                            </div>
                                            <div v-if="showDiscount(order) && order.discountPrice != order.price">
                                              <span class="sub-option-title">Зі знижкою:</span>
                                              <span class="option-value">{{ showDiscount(order) }}</span>
                                            </div>
                                            <div v-if="order.landingPromoCode">
                                              <span class="sub-option-title">Промокод «{{ order.landingPromoCode }}»:</span>
                                              <span class="option-value">&minus;{{ order.landingPromoAmount }} грн ({{ order.landingPromoPercent }}%)</span>
                                            </div>
                                            <div v-if="showDgoPrice(order)">
                                              <span class="sub-option-title">ДЦВ:</span>
                                              <span class="option-value">{{ showDgoPrice(order) }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Заробіток, грн</div>
                                          <div class="sub-options">
                                            <div v-if="order.isPartnerOrder">
                                              <span class="sub-option-title">Загальний:</span>
                                              <span v-if="order.allEarnings" class="option-value">{{ order.allEarnings }}</span>
                                              <span v-else class="option-value">&mdash;</span>
                                            </div>
                                            <div>
                                              <span class="sub-option-title">Ваш:</span>
                                              <span v-if="order.myEarnings" class="option-value">{{ order.myEarnings }}</span>
                                              <span v-else class="option-value">&mdash;</span>
                                            </div>
                                            <div v-if="order.isPartnerOrder">
                                              <span class="sub-option-title">Агента:</span>
                                              <span v-if="order.partnerEarnings" class="option-value">{{
                                                  order.partnerEarnings
                                                }}</span>
                                              <span v-else class="option-value">&mdash;</span>
                                            </div>
                                            <div v-if="showTerminated(order)">
                                              <span class="sub-option-title">Утримано за ДР:</span>
                                              <span class="option-value">{{ showTerminatedSum(order) }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row-mobile">
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Статус:</div>
                                          <el-row type="flex" class="mb-1">
                                            <el-col>
                                              <div :class="['option-value status w-100', getStatusClass(order)]">
                                                <span>{{ showStatusName(order) }}</span>
                                              </div>
                                              <div v-if="checkOrderPaid(order) && (showStatusId(order) === 5 || order.typeId === 5)">
                                                <div class="option-value payment-status status paid mt-1 w-100">
                                                  <span>Сплачено</span>
                                                </div>
                                              </div>
                                              <div v-if="checkOrderPaid(order) && getOrderPaymentSystemTitle(order)" class="option-value payment-system-badge mt-1 w-100">
                                                <PaymentSystemIcon class="payment-system-badge__icon" />
                                                <span>{{ getOrderPaymentSystemTitle(order) }}</span>
                                              </div>
                                              <div v-if="!checkOrderPaid(order) && (showStatusId(order) === 5 || showStatusId(order) === 10)">
                                                <div class="option-value payment-status status mt-1 w-100">
                                                  <span>Не сплачено</span>
                                                </div>
                                              </div>
                                              <div v-if="isCancellation(order)">
                                                <div class="option-value cancellation-status status mt-1 w-100">
                                                  <span>На ануляції</span>
                                                </div>
                                              </div>
                                              <div v-if="isProlongationOrder(order)"><!-- class="col-12 mb-3" -->
                                                <div class="option-value mt-1 w-100" style="margin-top: 8px; margin-left: 1px;">
                                                        <span>
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <line x1="10" y1="4" x2="10" y2="12" stroke="#EF4E4E" stroke-width="2"/>
                                                              <line x1="10" y1="13.5" x2="10" y2="16" stroke="#EF4E4E" stroke-width="2"/>
                                                              <circle cx="10" cy="10" r="9" stroke="#EF4E4E" stroke-width="2"/>
                                                            </svg>
                                                        </span>
                                                  <span style="margin-left: 1px;">
                                                            Скоро закінчується
                                                        </span>
                                                </div>
                                              </div>
                                              <file-input  v-if="order.manualTypeId && !checkOrderPaid(order) && (order.payments.length === 0 || order.payments.some(item => item.invoice.receipt === null))" class="option-value w-100 download-receipt" :http-request="(options) => uploadReceipt(options, order)" @remove-file="receiptLoaded = false" @upload-success="$emit('init-orders-list');">
                                                <template #button>
                                                  <div class="payment-status mt-1"><!--  h-auto d-inline-block p-1 -->
                                                    <span style="line-height: 22px">Завантажити квитанцію</span>
                                                  </div>
                                                </template>
                                              </file-input>
                                            </el-col>
                                          </el-row>
                                        </div>
                                      </div>
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Точка продажу:</div>
                                          <div class="option-value" v-if="showInsuredName(order) && showInsuredSurname(order)">
                                            <div class="option-value" v-if="showInsuredSurname(order)">
                                              {{ showInsuredSurname(order) }}
                                            </div>
                                            <div class="option-value" v-if="showInsuredName(order)">
                                              {{ showInsuredName(order) }}
                                            </div>
                                            <div class="option-value" v-if="showInsuredPatronymic(order)">
                                              {{ showInsuredPatronymic(order) }}
                                            </div>
                                          </div>
                                          <div v-else class="option-value" data-toggle="tooltip" data-placement="bottom" :title="showNameInsured(order)">
                                            {{ showNameInsured(order) }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row-mobile">
                                      <div class="col-6 half-block">
                                        <div class="info-block">
                                          <div class="option-title">Дата</div>
                                          <div class="sub-options">
                                            <div>
                                              <span class="sub-option-title fixed-width">Створений:</span>
                                              <span v-if="order.createdAt" class="option-value">{{ order.createdAt }}</span>
                                              <span v-else class="option-value">&mdash;</span>
                                            </div>
                                            <div>
                                              <span class="sub-option-title fixed-width">Початок:</span>
                                              <span v-if="showStartedAtContract(order)"
                                                    class="option-value">{{ showStartedAtContract(order) }}</span>
                                              <span v-else class="option-value">&mdash;</span>
                                            </div>
                                            <div>
                                              <span class="sub-option-title fixed-width">Закінчення:</span>
                                              <span v-if="showFinishedAtContract(order)"
                                                    class="option-value">{{ showFinishedAtContract(order) }}</span>
                                              <span v-else class="option-value">&mdash;</span>
                                            </div>
                                            <div v-if="showTerminated(order)">
                                              <span class="sub-option-title">Дата ДР:</span>
                                              <span v-if="showTerminated(order)"
                                                    class="option-value">{{ showTerminated(order) }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-6 half-block">
                                        <div  class="info-block options-block" style="margin-top: auto;color: #999DA6;">
                                          <div class="info-link" v-if="isProlongation(order)">
                                            <svg style="margin-bottom: 4px" width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M11.6 3.2002H4.4C3.07452 3.2002 2 4.27471 2 5.6002V11.6002C2 12.9257 3.07452 14.0002 4.4 14.0002H11.6C12.9255 14.0002 14 12.9257 14 11.6002V5.6002C14 4.27471 12.9255 3.2002 11.6 3.2002Z" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M5.59961 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M10.4004 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M2 6.80029H14" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <span @click="prolong(order)">Продовжити</span>

                                            <div class="d-inline-flex" style="margin-left: -10px;">
                                              <client-info :client="order.insurant"  ref="clientInfo"></client-info>
                                            </div>
                                          </div>
                                          <div class="info-link" v-else-if="isConcluded(order)">
                                            <svg width="16" height="16"
                                                 viewBox="0 0 17 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                              <g clip-path="url(#clip0)">
                                                <path
                                                  d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z"
                                                  stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                                <path
                                                  d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                                  stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                              </g>
                                              <defs>
                                                <clipPath id="clip0">
                                                  <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <span
                                              v-if="order.typeId === orderTypes['miniKasko']"
                                              @click="$router.push({name:'miniKaskoOrder', params: {orderId: order.id}})"
                                              class="show-btn"
                                            >Переглянути</span>
                                            <span v-else @click="goToOrderInfo(order)" class="show-btn">Переглянути</span>
                                          </div>
                                          <div class="info-link" v-else-if="isOverdue(order) && !isFisReferal() && !hideCopyForApiMethod(order)">
                                            <svg width="16" height="16" viewBox="0 0 17 16" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                              <path
                                                d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                                                stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                              <path
                                                d="M3.3335 10H2.66683C2.31321 10 1.97407 9.85952 1.72402 9.60947C1.47397 9.35942 1.3335 9.02028 1.3335 8.66666V2.66666C1.3335 2.31304 1.47397 1.9739 1.72402 1.72385C1.97407 1.4738 2.31321 1.33333 2.66683 1.33333H8.66683C9.02045 1.33333 9.35959 1.4738 9.60964 1.72385C9.85969 1.9739 10.0002 2.31304 10.0002 2.66666V3.33333"
                                                stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                            </svg>
                                            <span @click="copy(order)">Копіювати</span>
                                          </div>
                                          <div class="info-link" v-else-if="isDraft(order) && !isFisReferal()">
                                            <svg width="16" height="16" viewBox="0 0 17 16"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path
                                                d="M12.0415 7.74999C12.0398 8.88764 11.5871 9.9782 10.7827 10.7826C9.97822 11.5871 8.88766 12.0398 7.75001 12.0415C6.61223 12.0399 5.52149 11.5873 4.71686 10.7828C3.91223 9.97841 3.45936 8.88777 3.45751 7.74999C3.45896 6.61199 3.91167 5.52103 4.71636 4.71634C5.52104 3.91166 6.61201 3.45894 7.75001 3.45749C8.70651 3.45749 9.58251 3.77249 10.295 4.30049L9.40401 5.19249L13.619 6.32049L12.489 2.10699L11.544 3.05199C10.4712 2.18163 9.13151 1.70689 7.75001 1.70749C4.41301 1.70899 1.70901 4.41249 1.70801 7.74999C1.70901 11.0875 4.41301 13.7915 7.75001 13.7915C11.087 13.7915 13.7915 11.0875 13.7915 7.74999H12.0415Z"
                                                fill="#999DA6"/>
                                            </svg>
                                            <span
                                              v-if="order.typeId === orderTypes['miniKasko']"
                                              @click="$router.push({name:'miniKaskoOrder', params: {orderId: order.id}})"
                                              class="option"
                                            >Продовжити</span>
                                            <span v-else @click="declare(order)">Продовжити</span>
                                          </div>
                                          <div class="info-link" v-else-if="isDeclared(order) && !isFisReferal()">
                                            <svg width="16" height="16" viewBox="0 0 17 16"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path
                                                d="M12.0415 7.74999C12.0398 8.88764 11.5871 9.9782 10.7827 10.7826C9.97822 11.5871 8.88766 12.0398 7.75001 12.0415C6.61223 12.0399 5.52149 11.5873 4.71686 10.7828C3.91223 9.97841 3.45936 8.88777 3.45751 7.74999C3.45896 6.61199 3.91167 5.52103 4.71636 4.71634C5.52104 3.91166 6.61201 3.45894 7.75001 3.45749C8.70651 3.45749 9.58251 3.77249 10.295 4.30049L9.40401 5.19249L13.619 6.32049L12.489 2.10699L11.544 3.05199C10.4712 2.18163 9.13151 1.70689 7.75001 1.70749C4.41301 1.70899 1.70901 4.41249 1.70801 7.74999C1.70901 11.0875 4.41301 13.7915 7.75001 13.7915C11.087 13.7915 13.7915 11.0875 13.7915 7.74999H12.0415Z"
                                                fill="#999DA6"/>
                                            </svg>
                                            <span
                                              v-if="order.typeId === orderTypes['miniKasko']"
                                              @click="$router.push({name:'miniKaskoOrder', params: {orderId: order.id}})"
                                              class="option"
                                            >Продовжити</span>
                                            <span v-else @click="declare(order,false,false,2)">Продовжити</span>
                                          </div>
                                          <div class="info-link" v-else-if="isFisReferal()"></div>
                                          <div class="options-btn">
                                            <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                                 class="option-loader spinner-border"
                                                 style="height: 20px; width: 20px; margin-top: 11px;"
                                                 role="status">
                                            </div>
                                            <more-options style="padding-top: 5px"
                                                          v-else :status-order="showStatusId(order)"
                                                          @download-draft="downloadDraft(order)"
                                                          @download-contract="takeContract(order, 2)"
                                                          @download-acts-completed-work="showActsOfCompletedWork(order)"
                                                          @show-order="goToOrderInfo(order)"
                                                          @proceed-order="declare(order)"
                                                          @confirm-order="declare(order,false,false,2)"
                                                          @open-mtsbu-link="openMtsbuLink(order)"
                                                          @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                                          @get-payment-invoice="getPaymentInvoice(order)"
                                                          @get-instant-loan="getInstantLoan(order)"
                                                          :is-exist-mtsbu-link="showMtsbuLink(order)"
                                                          @copy-order="copy(order)"
                                                          :order="order"
                                                          :order-type="order.typeId"
                                                          :data-contract-extra-files="order.contract.extraFiles"
                                            >
                                            </more-options>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div v-if="showDgoPrice(order)" class="row-mobile additional-product">
                                        <div class="col-6 half-block">
                                            <div class="info-block">
                                                <div class="option-title">Тип поліса</div>
                                                <div class="option-value">ДЦВ</div>
                                            </div>
                                        </div>
                                        <div class="col-6 half-block">
                                            <div class="info-block">
                                                <div class="option-title">Вартість, грн</div>
                                                <div class="sub-options">
                                                    <div v-if="showDgoPrice(order)">
                                                        <span class="sub-option-title">Первісна:</span>
                                                        <span class="option-value">{{ showDgoPrice(order) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="info-block options-block" style="justify-content: flex-end">
                                              <div class="options-btn" style="margin-left: 0;">
                                                <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                                     class="option-loader spinner-border"
                                                     style="text-align: end; height: 20px; width: 20px; margin-top: 11px;"
                                                     role="status">
                                                </div>
                                                <more-options v-else :status-order="showStatusId(order)"
                                                              :order="order"
                                                              :order-type="4"
                                                              :data-contract-extra-files="order.contract.extraFiles"
                                                              @download-draft="showCrossProductDraft(order, 4)"
                                                              @download-contract="downloadDataCrossProduct(order, 4)"
                                                              @show-order="goToOrderInfo(order, 4)"
                                                              @proceed-order="declare(order,false,false,1)"
                                                              @confirm-order="declare(order,false,false,2)"
                                                              @open-mtsbu-link="openMtsbuLink(order)"
                                                              @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                                              @get-payment-invoice="getPaymentInvoice(order)"
                                                              @get-instant-loan="getInstantLoan(order)"
                                                              :is-exist-mtsbu-link="showMtsbuLink(order)"
                                                              @copy-order="copy(order)">
                                                </more-options>
                                              </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="showAutolawyerPrice(order)" class="row-mobile">
                                      <div class="col-6 half-block">
                                          <div class="info-block">
                                              <div class="option-title">Тип поліса</div>
                                              <div class="option-value">Автоюрист</div>
                                          </div>
                                      </div>
                                      <div class="col-6 half-block">
                                          <div class="info-block">
                                              <div class="option-title">Вартість, грн</div>
                                              <div class="sub-options">
                                                  <div v-if="showAutolawyerPrice(order)">
                                                      <span class="sub-option-title">Первісна:</span>
                                                      <span class="option-value">{{ showAutolawyerPrice(order) }}</span>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="info-block options-block" style="justify-content: flex-end">
                                              <div class="options-btn" style="margin-left: 0;">
                                                  <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                                       class="option-loader spinner-border"
                                                       style="text-align: end; height: 20px; width: 20px; margin-top: 11px;"
                                                       role="status">
                                                  </div>
                                                  <more-options v-else :status-order="showStatusId(order)"
                                                                :order="order"
                                                                :order-type="6"
                                                                :data-contract-extra-files="order.contract.extraFiles"
                                                                @download-draft="showCrossProductDraft(order, 6)"
                                                                @download-contract="downloadDataCrossProduct(order, 6)"
                                                                @show-order="goToOrderInfo(order, 6)"
                                                                @proceed-order="declare(order,false,false,1)"
                                                                @confirm-order="declare(order,false,false,2)"
                                                                @open-mtsbu-link="openMtsbuLink(order)"
                                                                @get-all-payment-ways="showAllOrderPaymentWays(order)"
                                                                @get-payment-invoice="getPaymentInvoice(order)"
                                                                @get-instant-loan="getInstantLoan(order)"
                                                                :is-exist-mtsbu-link="showMtsbuLink(order)"
                                                                @copy-order="copy(order)">
                                                  </more-options>
                                              </div>
                                          </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </history-tabs>
        <modal-get-invoice-order ref="modalGetInvoiceOrder"></modal-get-invoice-order>
        <modal-get-invoice-legal-order ref="modalGetInvoiceLegalOrder"></modal-get-invoice-legal-order>
        <modal-get-instant-loan ref="modalGetInstantLoan"></modal-get-instant-loan>
        <modal-get-mono-pay-parts ref="showModalGetMonoPayParts"></modal-get-mono-pay-parts>
        <modal-get-all-payment-ways
            ref="modalGetAllPaymentWays"
            @showModalGetInvoiceOrder="getPaymentInvoice"
            @showModalGetInstantLoan="getInstantLoan"
            @showModalGetMonoPayParts="showModalGetMonoPayParts"
            @showModalGetInvoiceLegal="showModalGetInvoiceLegal"
            :is-legal-type="false"
            :company-id="paymentWaysCompanyId"
        >
        </modal-get-all-payment-ways>

        <modal-error-take-contract ref="showModalErrorTakeContract">
            <template v-slot:modal-title>
                <div class="text-center">
                    <div style="display: inline-block; width: 100%; margin-top: 60px;">
                        <svg height="50px" width="50px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23.612 23.612" xml:space="preserve">
                            <g><g><g><path style="fill:#cd7101;" d="M16.192,5.224V4.487h-8.77v0.737c0,0,1.334,3.713,3.838,5.428v1.785c0,0-2.761,2.686-3.838,5.775v0.842h8.77v-0.842c-1.399-3.41-3.837-5.775-3.837-5.775v-1.785C15.759,7.726,16.192,5.224,16.192,5.224z"/></g>
                                  <g><path style="fill:#010002;" d="M19.353,3.856V2.529h1.258V0H3.002v2.529h1.259v1.327c0,2.025,3.634,7.555,3.804,7.955c-0.167,0.397-3.804,5.929-3.804,7.946v1.325H3.002v2.53h17.609v-2.53h-1.258v-1.325c0-2.025-3.635-7.521-3.829-7.951C15.718,11.376,19.353,5.88,19.353,3.856z M18.096,19.757v1.325H5.519v-1.325c0-1.455,3.854-7.222,3.854-7.951s-3.854-6.495-3.854-7.95V2.529h12.578v1.327c0,1.455-3.886,7.221-3.886,7.95C14.21,12.535,18.096,18.302,18.096,19.757z"/>
                                  </g></g>
                            </g>
                        </svg>
                    </div>
                    <div class="message">Договір у процесі формування</div>
                </div>
            </template>
            <template v-slot:modal-content>
                <div class="text-center"><div class="modal-text-item">Будь ласка, спробуйте завантажити документ через кілька хвилин.</div><br></div>
            </template>
        </modal-error-take-contract>
<!--        <policy-cancel-dialog/>-->
    </div>
</template>


<script>
import Vue from 'vue';
import { ClientInfo, MoreOptions, RowBlockSkeleton, RowBlockCompactSkeleton, RowMobileBlockSkeleton, OrderCardCompact, CrossProductCard } from './components';
import { downloadTourismContract } from '@/api/downloadTourismContract';
import { orderTourism } from '@/api/orderTourism';
import FileInput from '@/components/app/forms/FileInput.vue';
import {
  GetAllPaymentWays as ModalGetAllPaymentWays,
  GetInstantLoan as ModalGetInstantLoan,
  GetPaymentLink as ModalGetInvoiceOrder,
  GetMonoPayParts as ModalGetMonoPayParts,
  CustomWarningError as ModalErrorTakeContract,
} from '@/components/app/modals/order';
import ModalGetInvoiceLegalOrder from '@/components/app/modals/order/GetInvoiceLegalOrder.vue';
import PolicyCancelDialog from '@/components/app/policyCancel/PolicyCancelDialog.vue';
import { customerMixin, HistoryMixin, orderMixin, userMixin } from '@/mixin';
import displaySettings from '@/mixin/displaySettings';
import EmptyState from '@/views/history/components/EmptyState.vue';
import HistoryTabs from '@/views/history/components/HistoryTabs.vue';
import { PaymentSystemIcon } from '@/shared/ui/icons';

export default {
  mixins: [orderMixin, customerMixin, HistoryMixin, displaySettings, userMixin],
  components: {
    FileInput,
    HistoryTabs,
    EmptyState,
    PolicyCancelDialog,
    MoreOptions,
    PaymentSystemIcon,
    RowBlockSkeleton,
    RowBlockCompactSkeleton,
    RowMobileBlockSkeleton,
    ClientInfo,
    ModalGetInvoiceOrder,
    ModalGetInvoiceLegalOrder,
    ModalGetInstantLoan,
    ModalGetMonoPayParts,
    ModalGetAllPaymentWays,
    ModalErrorTakeContract,
    OrderCardCompact,
    CrossProductCard
  },
  props: {
    loadingParent: {
      type: Boolean,
      default: false
    },
    countProlongation: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    isLoadData: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    trashActsList: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    showActsColumnStatus: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    filterButtonEvent: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    prolongation: {
      type: Array,
      default: () => {
        return [{
          dgo: {},
          autolawyer: {},
          statusId: null,
          fullName: null,
          earning: null,
          contract: {},
          companyInfo: {},
          insurant: {},
          insured: {},
          price: null,
          dgoPrice: null,
          discountPrice: null,
          cashbackPrice: null,
        }];
      },
    },
    orders: {
      type: Array,
      default: () => {
        return [{
          dgo: {},
          autolawyer: {},
          statusId: null,
          fullName: null,
          earning: null,
          contract: {},
          contractDgo: {},
          companyInfo: {},
          insurant: {},
          insured: {},
          price: null,
          dgoPrice: null,
          discountPrice: null,
          cashbackPrice: null,
        }];
      },
    },
    initWhollyOrders: Function,
    listActsTerminated: {
      type: Object,
      default: () => { return {};}
    },
    allOrders: {
      type: Array,
      default: () => {
        return [{
          dgo: {},
          autolawyer: {},
          statusId: null,
          fullName: null,
          earning: null,
          contract: {},
          contractDgo: {},
          companyInfo: {},
          insurant: {},
          insured: {},
          price: null,
          dgoPrice: null,
          discountPrice: null,
          cashbackPrice: null,
        }];
      },
    },
    ordersViewMode: {
      type: String,
      default: () => {
        return 'full';
      }
    },
  },
  data: function () {
    return {
      showActsColumn: false,
      loadAllData: false,
      listActs: {},
      loadMoreOptions: {},
      ordersList: [],
      allOrdersList: [],
      ordersResponceList: [],
      listQuery: {
        statusId: 0,
      },
      humans : [],
      birthDates: [],
    };
  },
  created() {
    this.ordersList = this.orders;
    this.allOrdersList = this.allOrders;
    this.updateTooltip();
  },
  computed: {
    computedOrdersList() {
      return this.ordersList.map(order => ({
        ...order,
        showCheckbox: this.isShowCheckBox(order)
      }));
    },
    margeActsList: function () {
      return {
        ...this.listActsTerminated,
        ...this.listActs,
      };
    },
    orderTypes: function () {
      return this.$store.getters.ORDER_TYPES;
    },
    showPriceDetails(){
      let text;
      text =
                    '<div class=\'details-acts-tooltip\'> ' +
                    '<div class=\'details-act\'>' +
                    '      <div class="tooltip-row">' +
                    '        <span class="tooltip-label">Обрано полісів:</span>' +
                    '        <span class="tooltip-value">'+ (Object.keys(this.margeActsList).length)+'</span>';
      text += '</div> ';
      '</div>';
      return text;
    },
  },
  methods: {
    isFisReferal(){
      return parseInt(this.$store.getters.USER?.recipientTypeId) == 4;
    },
    aktsToggle: function(order, event){
      if(event.target.checked){
        this.$set(this.listActs,order.id, order);
      }else{
        this.$delete(this.listActs, order.id);
      }
    },
    generatePdfPreview() {
      if(this.loadAllData || this.loadAllDataTerminated || this.loadingParent) return;
      this.$emit('generate-pdf-preview');
    },
    changeOrdersView(mode) {
      this.$emit('change-orders-view');
    },
    filterStatusWrap: function() {
      return this.$emit('filter-status-wrap');
    },
    showTouristDraft: async function(order) {
      Vue.set(this.loadMoreOptions, order.id + order.typeId, true);

      let params = {
        type: 'save',
        statusId: null,
      };

      let offerInfo = {
        'id':order.offer.external_id,
        'company':order.companyInfo.info,
        'tripProgram':order.offer.trip_program,
        'title':order.companyInfo.name,
        'options':order.offer.options,
        'programs':order.offer.programs,
        'members':order.offer.members,
        'ages':order.offer.ages,
        'external_id':order.offer.external_id,
        'startDate':order.offer.startDate,
        'endDate':order.offer.endDate,
        'moduleId':order.moduleId,
        'period_option':order.offer.period_option,
        'risks':order.offer.risks,
        'price':order.offer.price,
        'limit':order.offer.coverage,
        'limit_currency':order.offer.limit_currency,
        'offerId':order.offer.id,
        'purposeOfTrip':order.offer.purposeOfTrip,
        'fullPrice':order.allPrice,
        'yearProgram':order.offer.yearProgram
      };

      let TouristsList = [];

      order.insurants.forEach((insurant) => {
        TouristsList.push({ name: insurant.name, surname: insurant.surname, dateBirth: insurant.dateBirthAt, identificationCode: insurant.documentation.uin,
          withoutIdentificationCode: insurant.documentation.withoutUin,
          passportSerial: insurant.documentation.serial, passportNumber: insurant.documentation.number, passportDate: insurant.documentation.dateOfIssue });
      });

      let userInfo = {
        'identificationCode':order.insurant.documentation.uin,
        'withoutIdentificationCode':order.insurant.documentation.withoutUin,
        'name':order.insurant.name,
        'surname':order.insurant.surname,
        'dateBirth':order.insurant.dateBirthAt,
        'phone':order.insurant.phone,
        'mail':order.insurant.email,
        'city':order.insurant.cityObject,
        'street':order.insurant.street,
        'house':order.insurant.house,
        'apartment':order.insurant.apartment,
        'documentType':order.insurant.documentation.documentType,
        'passportSerial':order.insurant.documentation.serial,
        'passportNumber':order.insurant.documentation.number,
        'passportDate':order.insurant.documentation.dateOfIssue
      };

      const searchParamsTourism = {
        date: order.offer.startDate,
        end: order.offer.endDate,
        days: order.offer.period_option,
        country: { id:order.offer.country.id,ewa_id:order.offer.country.ewa_id,name:order.offer.country.name },
        tourists: order.offer.tourists,
        humans: this.humans,
        yearProgram: order.offer.yearProgram,
        birthDates: this.birthDates,
        filters: {
          'franchise': '',
          'options_list': [],
          'activities': {
            'name': 'Без активності',
            'value': 'no_activities'
          },
          'activitiesItem': 'Без активностей'
        },
        activities: 'no_activities',
      };

      let response = '';

      if (order.contract && order.contractId) {

        response = await downloadTourismContract(order.contractId);

        Vue.set(this.loadMoreOptions, order.id + order.typeId, false);

        if (response?.data?.data?.contractDraft_path) {
          window.open(response.data.data.contractDraft_path);
        } else {
          this.$alert('Спробуйте пізніше');
        }

        return true;
      } else {
        orderTourism(offerInfo, searchParamsTourism, userInfo, TouristsList, order.id, params).then((response) => {

          Vue.set(this.loadMoreOptions, order.id + order.typeId, false);

          if (response && response.data.count >= 1) {
            const contractData = response.data.data[0];

            if (contractData.contractDraft_path) {
              window.open(contractData.contractDraft_path);
            } else {
              this.$alert('Спробуйте пізніше');
            }
          } else {
            this.$alert('Чернетка не сбережена. Спробуйте ще раз', '', 'error', { width: '300px' });
          }

        }).catch((error) => { console.error(error);
          $('#modalPayAnimation').modal('hide');
          Vue.set(this.loadMoreOptions, order.id + order.typeId, false);
          this.$alert('Щось пішло не так. Чернетка не сбережена.');
        });
      }
    },
    prolong: async function(order) {
      await this.copy(order, true);
    },
    activateTab :function (status) {
      this.$set(this.listQuery, 'statusId', status.id);
    },
    takeContract: async function (order, type) {
      if (order.typeId === this.orderTypes['miniKasko']) {
        return window.open(`/api/insurance/mini-kasko/orders/${order.id}/download?t=${Date.now()}`)
      }

      if (order.typeId == 1 && order.dgo) {
        this.ordersResponceList = await this.downloadData(order, this.ordersList, type);
      } else {
        this.downloadData(order, this.ordersList, 1);
      }
    },
  },
  watch: {
    'showActsColumnStatus': function (newValue, oldValue) {
      this.updateTooltip();
    },
    'listQuery.statusId': function (newValue, oldValue) {
      return this.$emit('init-orders-list', true);
    },
    'trashActsList': function (newValue, oldValue) {
      if(newValue){
        this.listActs = {};
      }
    },
    'margeActsList': {
      handler: function (val, oldVal) {
        this.$emit('init-list-acts',this.listActs);
        this.updateTooltip();
      },
      deep: true
    },
    'orders': {
      handler: function (val, oldVal) {
        this.ordersList = val;
        if(this.filterButtonEvent == true){
          this.listActs = {};
          this.showActsColumn = false;
        }
      },
      deep: true
    },
    'ordersResponceList': {
      handler: function (val, oldVal) {
        this.ordersList = this.updateExtraFiles(this.ordersList, val);
      },
      deep: true
    },
  }
};
</script>

<style lang="scss" scoped>
.status-badges-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.payment-system-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
  font-size: 12px;
  color: #999DA6;

  &__icon {
    flex-shrink: 0;
  }
}
.option {
  color: #24282C;
  cursor: pointer;
}
input[type='checkbox'] {
  position: relative;
  width: 14px;
  height: 14px;
  background-color: #ffffff;
  border: 1px solid #717084;
  border-radius: 2px;
  -webkit-appearance: none;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:checked {
    background-color: #292438;

    &::after {
      opacity: 1;
    }
  }
}

.column-akt-mobile {
  display: flex;
  align-items: center;

  label {
    font-family: Circe,serif;
    font-weight: normal;
    font-size: 13px;
    line-height: 22px;
    color: #24282C;
    margin-right: 5px;
  }
}
</style>
